import * as React from "react";
import NextImage from "next/image";

import ResponsiveStack from "components/Chakra/ResponsiveStack";
import CustomLink from "components/Chakra/CustomLink";

const CheckPreview: React.FunctionComponent = () => (
  <ResponsiveStack alignItems="center">
    <NextImage
      priority
      src="/img/common/report_provereni.jpg"
      alt="Náhled reportu proveření"
      width="350"
      height="435"
    />
    <CustomLink href="/documents/ccreport.pdf" isExternal mt="3">
      Zobrazit náhled
    </CustomLink>
  </ResponsiveStack>
);

export default CheckPreview;
